import { Box, Checkbox, FormControlLabel, Grid, MenuItem, Select, TextField } from "@mui/material";
import * as React from "react";
import { TextFieldWithButtonLabel } from "source/components/framework/Form/TextFieldWithButtonLabel";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";
import { CompanyActiveState } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import * as store from "../../../framework/customStore";
import { ICodeTitle } from "../../../models/common/codeTitle";
import { ICompanyEditItem } from "../../../models/company/companyEditItem";
import { CompanyListItem } from "../../../models/company/companyListItem";
import { ISessionState } from "../../../models/session/sessionState";
import * as storeActions from "../../../models/store/storeActions";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";
import { ProgressBar } from "ui/Scripts/source/components/framework/ProgressBar/ProgressBar";
import { ModifyUserInfo } from "../../framework/User/ModifyUserInfo";

export interface ICompanyEditBasicInformationProp {
    sessionState: ISessionState;
    company: ICompanyEditItem;
    customStyles: ICodeTitle[];
    adminMode: boolean;
    usedFileStorageQuota: number;
    //Company data
    name: string;
    postalAddress: string;
    postalCode: string;
    city: string;
    phone: string;
    email: string;
    internet: string;
    pageFooterText: string;
    businessIdentityCode: string;
    contactPerson: string;
    logo: string;
    resetLogo: boolean;
    logoSquare: string;
    resetLogoSquare: boolean;
    styleClass: string;
    usedStoragePercent: number;
    eInvoiceAddress: string;
    eInvoiceOperator: string;
    minPasswordLength: number;
    //Admin Company data
    code: string;
    loginUrl: string;
    loginAllowMicrosoft: boolean;
    fileStorageQuota: string;
    customStyleClass: string;
    tiedostoturvaUseType: number;
    activeState: number;
    documentRootPath: string;
    bannerPath: string;
    documentPreviewLogType: number;
    onChange: (name: string, value: string) => void;
    onChangeLogo: (main: boolean, file: File) => void;
    onRemoveLogo: (main: boolean) => void;
}

export class CompanyEditBasicInformation extends React.Component<ICompanyEditBasicInformationProp, {}> {
    handleChange = (event) => {
        const target = event.target;
        this.props.onChange(target.name !== "xts" ? target.name : "code", target.value);
    };

    handleIntBlur = (event) => {
        const target = event.target;
        const value: string = target.value;
        const int = value.toInteger();
        this.props.onChange(target.name !== "xts" ? target.name : "code", int ? int.toString(10) : "0");
    };
   
    render() {
        const props = this.props;
        const company = props.company;
        if (!company) return null;
        const isNew = company.isNew();
        const adminMode = props.adminMode && props.sessionState.isSuperAdmin;
        return (
            <GridRow>
                <Grid item sm={12} md={adminMode ? 4 : 6}>
                    {adminMode &&
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.Code} required margin={0}>
                                        <TextField type="text" name="xts" title={Translations.Code} inputProps={{ maxLength: 50 }} disabled={false} value={props.code} onChange={this.handleChange} />
                                    </FormField>
                                </Grid>
                            </GridRow>
                    }
                    <GridRow>
                        <Grid item sm={12}>
                            <FormField title={Translations.CompanyName} required margin={!adminMode ? 0 : undefined}>
                                <TextField type="text" name="name" title={Translations.CompanyName} inputProps={{ maxLength: 50 }} disabled={false} value={props.name} required={true} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                    </GridRow>
                    <GridRow>
                        <Grid item sm={12}>
                            <FormField title={Translations.PostalAddress}>
                                <TextField type="text" name="postalAddress" title={Translations.PostalAddress} inputProps={{ maxLength: 50 }} disabled={false} value={props.postalAddress} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                    </GridRow>
                    <GridRow>
                        <Grid item sm={4}>
                            <FormField title={Translations.PostalCode}>
                                <TextField type="text" name="postalCode" title={Translations.PostalCode} inputProps={{ maxLength: 10 }} disabled={false} value={props.postalCode} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                        <Grid item sm={8}>
                            <FormField title={Translations.City}>
                                <TextField type="text" name="city" title={Translations.City} inputProps={{ maxLength: 50 }} disabled={false} value={props.city} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                    </GridRow>
                    <GridRow>
                        <Grid item sm={4}>
                            <FormField title={Translations.Phone}>
                                <TextField type="text" name="phone" title={Translations.Phone} inputProps={{ maxLength: 50 }} disabled={false} value={props.phone} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                        <Grid item sm={8}>
                            <FormField title={Translations.EmailAddress}>
                                <TextField type="text" name="email" title={Translations.EmailAddress} inputProps={{ maxLength: 50 }} disabled={false} value={props.email} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                    </GridRow>
                    <GridRow>
                        <Grid item sm={4}>
                            <FormField title={Translations.BusinessIdentityCode}>
                                <TextField type="text" name="businessIdentityCode" title={Translations.BusinessIdentityCode} inputProps={{ maxLength: 20 }} disabled={false} value={props.businessIdentityCode} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                        <Grid item sm={8}>
                            <FormField title={Translations.Internet}>
                                <TextField type="text" name="internet" title={Translations.Internet} inputProps={{ maxLength: 50 }} disabled={false} value={props.internet} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                    </GridRow>
                    {(!isNew && !props.adminMode) &&
                        <GridRow>
                            <Grid item sm={12}>
                                <FormField title={Translations.Modified}>
                                    <ModifyUserInfo
                                        modifyUser={props.company.modifyUser}
                                    />
                                </FormField>
                            </Grid>
                        </GridRow>
                    }
                </Grid>
                <Grid item sm={12} md={adminMode ? 4 : 6}>
                    <GridRow>
                        <Grid item sm={6}>
                            <FormField title={Translations.EInvoiceAddress} margin={0}>
                                <TextField type="text" name="eInvoiceAddress" title={Translations.EInvoiceAddress} inputProps={{ maxLength: 35 }} disabled={false} value={props.eInvoiceAddress} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                        <Grid item sm={6}>
                            <FormField title={Translations.EInvoiceOperator} margin={0}>
                                <TextField type="text" name="eInvoiceOperator" title={Translations.EInvoiceOperator} inputProps={{ maxLength: 35 }} disabled={false} value={props.eInvoiceOperator} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                    </GridRow>
                    <GridRow>
                        <Grid item sm={12}>
                            <FormField title={Translations.ContactPerson}>
                                <TextField name="contactPerson" title={Translations.ContactPerson} inputProps={{ maxLength: 500 }} disabled={false} multiline minRows={5} value={props.contactPerson} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                    </GridRow>
                    <GridRow>
                        <Grid item sm={props.customStyles.length > 0 ? 6 : 12}>
                            <FormField title={Translations.MinimumPasswordLength}>
                                <TextFieldWithButtonLabel label={Translations.Characters} type="text" name="minPasswordLength" title={Translations.MinimumPasswordLength} inputProps={{ maxLength: 2 }} disabled={false} value={props.minPasswordLength} onChange={this.handleChange} onBlur={this.handleIntBlur} />
                            </FormField>
                        </Grid>
                        {/* {props.customStyles.length > 0 &&
                            <Grid item sm={6}>
                                <FormField title={Translations.WebPageStyle}>
                                    <Select name="styleClass" title={Translations.WebPageStyle} value={props.styleClass} onChange={this.handleChange}>
                                        {props.customStyles.map((customStyle) =>
                                            <MenuItem key={customStyle.code} value={customStyle.code}>{customStyle.title}</MenuItem>
                                        )}
                                    </Select>
                                </FormField>
                            </Grid>
                        } */}
                    </GridRow>
                    {/* {adminMode && (
                        <GridRow>
                            <Grid item sm={12}>
                                <FormField title={Translations.CustomStyleClass}>
                                    <TextField type="text" name="customStyleClass" title={Translations.CustomStyleClass} inputProps={{ maxLength: 50 }} disabled={false} value={props.customStyleClass} onChange={this.handleChange} />
                                </FormField>
                            </Grid>
                        </GridRow>
                    )} */}
                    <GridRow>
                        <Grid item sm={9}>
                            <FormField title={Translations.Logo}>
                                <Box sx={{ maxWidth: "290px", position: "relative" }}>
                                    <AvatarImage
                                        marginRight="10px"
                                        name={Translations.Logo}
                                        image={props.logo}
                                        editable={true}
                                        size={60}
                                        logo
                                        objectFit="contain"
                                        tooltip={Translations.CkickToChangeThePicture}
                                        removeTooltip={Translations.RemovePicture}
                                        onChange={(file: File) => props.onChangeLogo(true, file)}
                                        onClear={props.resetLogo ? null : () => props.onRemoveLogo(true)}
                                        onError={(message) => { store.customStore.dispatch(storeActions.showErrorMessage(message)); }}
                                    />
                                </Box>
                            </FormField>
                        </Grid>
                        <Grid item sm={3}>
                            <FormField title={Translations.LogoSquare}>
                                <Box sx={{ maxWidth: "45px", position: "relative" }}>
                                    <AvatarImage
                                        marginRight="10px"
                                        name={Translations.LogoSquare}
                                        image={props.logoSquare}
                                        editable={true}
                                        size={30}
                                        tooltip={Translations.CkickToChangeThePicture}
                                        removeTooltip={Translations.RemovePicture}
                                        onChange={(file: File) => props.onChangeLogo(false, file)}
                                        onClear={props.resetLogoSquare ? null : () => props.onRemoveLogo(false)}
                                        onError={(message) => { store.customStore.dispatch(storeActions.showErrorMessage(message)); }}
                                    />
                                </Box>
                            </FormField>
                        </Grid>
                    </GridRow>
                    {!!props.fileStorageQuota && props.fileStorageQuota !== "0" &&
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.UsedFileStorageQuota}>
                                        <ProgressBar
                                            text={props.usedStoragePercent + " % / " + props.usedFileStorageQuota.toLocaleFixed(2) + " GB"}
                                            tooltip={String.format(Translations.ParameterPercentOfFileStorageQuotaUsed, props.usedStoragePercent)}
                                            value={props.usedStoragePercent}
                                            color={props.usedStoragePercent < 75.1 ? "info" : (props.usedStoragePercent < 90.1 ? "warning" : "error")}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                    }
                </Grid>
                {adminMode &&
                        <Grid item sm={12} md={4}>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.LoginAddress} margin={0}>
                                        <TextField type="text" name="loginUrl" title={Translations.LoginAddress} inputProps={{ maxLength: 250 }} disabled={false} value={props.loginUrl} onChange={this.handleChange} />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title="" margin="1rem 0 -.5rem">
                                        <FormControlLabel
                                            label={Translations.LoginAllowMicrosoft}
                                            control={
                                                <Checkbox
                                                    checked={props.loginAllowMicrosoft}
                                                    onChange={(_e, checked: boolean) => props.onChange("loginAllowMicrosoft", checked ? "1" : "0")}
                                                />
                                            }
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.PageFooterText}>
                                        <TextField type="text" name="pageFooterText" title={Translations.PageFooterText} inputProps={{ maxLength: 250 }} disabled={false} value={props.pageFooterText} onChange={this.handleChange} />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow sx={{ alignItems: "flex-end" }}>
                                <Grid item sm={6}>
                                    <FormField title={Translations.ActiveState}>
                                        <Select name="activeState" title={Translations.ActiveState} value={props.activeState.toString(10)} onChange={this.handleChange}>
                                            <MenuItem key={CompanyActiveState.NotInUse} value={CompanyActiveState.NotInUse.toString(10)}>{CompanyListItem.getActiveStateToStr(CompanyActiveState.NotInUse)}</MenuItem>
                                            <MenuItem key={CompanyActiveState.InTesting} value={CompanyActiveState.InTesting.toString(10)}>{CompanyListItem.getActiveStateToStr(CompanyActiveState.InTesting)}</MenuItem>
                                            <MenuItem key={CompanyActiveState.InUse} value={CompanyActiveState.InUse.toString(10)}>{CompanyListItem.getActiveStateToStr(CompanyActiveState.InUse)}</MenuItem>
                                        </Select>
                                    </FormField>
                                </Grid>
                                <Grid item sm={6}>
                                    <FormControlLabel
                                        label={Translations.TiedostoturvaUseType}
                                        control={
                                            <Checkbox
                                                checked={props.tiedostoturvaUseType > 0.5}
                                                onChange={(_e, checked: boolean) => props.onChange("tiedostoturvaUseType", checked ? "1" : "0")}
                                            />
                                        }
                                    />
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.DocumentRootPath} required>
                                        <TextField type="text" name="documentRootPath" title={Translations.DocumentRootPath} inputProps={{ maxLength: 250 }} disabled={false} value={props.documentRootPath} onChange={this.handleChange} />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.FileStorageQuotaGB} required>
                                        <TextField type="text" name="fileStorageQuota" title={Translations.FileStorageQuotaGB} inputProps={{ maxLength: 5 }} disabled={false} value={props.fileStorageQuota} onChange={this.handleChange} onBlur={this.handleIntBlur} />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.BannerPath}>
                                        <TextField type="text" name="bannerPath" title={Translations.BannerPath} inputProps={{ maxLength: 250 }} disabled={false} value={props.bannerPath} onChange={this.handleChange} />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12} sx={{ marginTop: "1rem" }}>
                                    <FormControlLabel
                                        label={Translations.LogDocumentPreview}
                                        control={
                                            <Checkbox
                                                checked={props.documentPreviewLogType > 0.5}
                                                onChange={(_e, checked: boolean) => props.onChange("documentPreviewLogType", checked ? "1" : "0")}
                                            />
                                        }
                                    />
                                </Grid>
                            </GridRow>
                        </Grid>
                }
            </GridRow>
        );
    }
}